"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ProductUpdateView = _interopRequireDefault(require("./ProductUpdateView"));

var _qs = _interopRequireDefault(require("qs"));

var _axios = _interopRequireDefault(require("axios"));

var _FilterPill = _interopRequireDefault(require("../filter-pill/FilterPill"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _categories = require("@insided/shared/utils/categories");

var _classnames = _interopRequireDefault(require("classnames"));

var _shared = require("@insided/destination/modules/Navigation/shared");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'product-updates-overview';
exports.cssAnchorName = cssAnchorName;
var MAX_DISPLAYABLE_COUNT = 10000;

var formatCount = function formatCount(count) {
  if (count >= MAX_DISPLAYABLE_COUNT) {
    return "".concat(MAX_DISPLAYABLE_COUNT, "+");
  }

  return count.toString();
};

var ProductUpdatesOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductUpdatesOverview, _Component);

  var _super = _createSuper(ProductUpdatesOverview);

  function ProductUpdatesOverview(props) {
    var _props$categories;

    var _this;

    (0, _classCallCheck2.default)(this, ProductUpdatesOverview);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isPageNumberIncreased", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showBackButton", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "categoryMapping", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "filtersList", ['productArea', 'category', 'productAreaSectionId']);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      productUpdates: _this.props.productUpdates,
      currentPage: parseInt(_this.props.currentPage),
      totalPageCount: _this.props.totalPageCount,
      totalTopicCount: _this.props.totalTopicCount
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPagination", function (newPage) {
      if (newPage > _this.state.currentPage) {
        _this.isPageNumberIncreased = true;
      }

      _this.setState({
        currentPage: newPage
      }, function () {
        return (0, _shared.setQueryParams)({
          page: _this.state.currentPage
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getNewTopicsList", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var params, res;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = (0, _shared.getParamsForUnified)();

              _this.setState({
                isLoading: true
              });

              _context.prev = 2;
              _context.next = 5;
              return _axios.default.get('/productUpdates/topics', {
                params: params
              });

            case 5:
              res = _context.sent;

              if (res.data) {
                // Hide show back button if filters are changing except pagination
                if (!_this.isPageNumberIncreased) {
                  _this.showBackButton = false;
                }

                _this.setState(function (prevState) {
                  return {
                    productUpdates: _this.isPageNumberIncreased ? prevState.productUpdates.concat(res.data.topics) : res.data.topics,
                    currentPage: _this.isPageNumberIncreased ? prevState.currentPage : 1,
                    totalPageCount: res.data.totalPageCount,
                    totalTopicCount: res.data.totalTopicCount,
                    isLoading: false
                  };
                });

                _this.isPageNumberIncreased = false;
              }

              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              _this.isPageNumberIncreased = false;

              _this.setState({
                isLoading: false
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    })));

    if ((_props$categories = props.categories) !== null && _props$categories !== void 0 && _props$categories.length) {
      _this.categoryMapping = (0, _categories.getCategoryIdTitleMapping)(props.categories);
    }

    _this.showBackButton = parseInt(props.currentPage) !== 1;
    return _this;
  }

  (0, _createClass2.default)(ProductUpdatesOverview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (typeof window === 'undefined') {
        return;
      }

      ProductUpdatesOverview.overrideHistoryPushState();

      window.history.onpushstate = function () {
        // pushstate is async event, without setTimeout it is getting previous state
        window.setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.getNewTopicsList();

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })), 0);
      };

      window.addEventListener('popstate', ProductUpdatesOverview.handleBackNavigation);
    }
  }, {
    key: "render",
    value: function render() {
      var _qs$parse$filters,
          _this3 = this,
          _ref3;

      var _this$props = this.props,
          isGuest = _this$props.isGuest,
          currentUser = _this$props.currentUser,
          productAreasMapping = _this$props.productAreasMapping,
          productAreas = _this$props.productAreas;
      var _this$state = this.state,
          productUpdates = _this$state.productUpdates,
          isLoading = _this$state.isLoading,
          totalPageCount = _this$state.totalPageCount,
          currentPage = _this$state.currentPage,
          totalTopicCount = _this$state.totalTopicCount;
      var searchQuery = typeof window !== 'undefined' ? window.location.search : '';
      var filters = (_qs$parse$filters = _qs.default.parse(searchQuery, {
        ignoreQueryPrefix: true
      }).filters) !== null && _qs$parse$filters !== void 0 ? _qs$parse$filters : {};
      var filterKeys = Object.keys(filters).filter(function (filter) {
        return _this3.filtersList.includes(filter);
      });
      var selectedProductAreaIds = (_ref3 = filters.productArea) !== null && _ref3 !== void 0 ? _ref3 : [];

      if (typeof window !== 'undefined') {
        if (filterKeys.length) {
          document.body.classList.add('filters-applied');
        } else {
          document.body.classList.remove('filters-applied');
        }
      }

      return (0, _preact.h)("div", {
        className: "product-updates-overview-wrapper"
      }, (0, _preact.h)("div", {
        className: "product-updates-overview"
      }, (productAreas === null || productAreas === void 0 ? void 0 : productAreas.length) > 0 && (0, _preact.h)("div", {
        className: "product-area-mobile-filter is-hidden-L"
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "filter.by.product"
      })), (0, _preact.h)("ul", {
        className: "product-area-mobile-filter__list"
      }, (0, _preact.h)("li", null, (0, _preact.h)("button", {
        type: "button",
        className: (0, _classnames.default)('product-area-mobile-filter__item', {
          selected: selectedProductAreaIds.length === 0
        }),
        onClick: function onClick() {
          return ProductUpdatesOverview.onProductAreaSelect(null);
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "all.products"
      }))), productAreas.flatMap(function (pa) {
        return pa.isSection ? pa.children : [pa];
      }).map(function (pa) {
        return (0, _preact.h)("li", {
          key: pa.id
        }, (0, _preact.h)("button", {
          type: "button",
          className: (0, _classnames.default)('product-area-mobile-filter__item', {
            selected: selectedProductAreaIds.includes(String(pa.id))
          }),
          onClick: function onClick() {
            return ProductUpdatesOverview.onProductAreaSelect(pa.id);
          }
        }, pa.name));
      }))), filterKeys.length ? (0, _preact.h)("ul", {
        className: "filter-list is-hidden-L"
      }, filterKeys.filter(function (key) {
        return key !== 'productArea';
      }).map(function (filterKey) {
        var filterValue = filters[filterKey][0];
        return (0, _preact.h)(_FilterPill.default, {
          key: filterValue,
          name: (0, _shared.getFilterName)(filterKey, filterValue, _this3.categoryMapping),
          onClick: function onClick() {
            return (0, _shared.dispatchFilterRemovalEvent)(filterKey);
          },
          isDismissable: true
        });
      })) : null, filterKeys.length ? (0, _preact.h)("header", {
        className: "product-updates-list-header"
      }, (0, _preact.h)("h3", {
        className: "list__items--header-heading qa-thread-list-count"
      }, (0, _preact.h)(_phrase.default, {
        p: "product.updates.counter",
        count: {
          n: formatCount(totalTopicCount)
        }
      }))) : null, this.showBackButton ? (0, _preact.h)("div", {
        className: (0, _classnames.default)('load-more-container', 'back-to-top-button', 'card-widget-wrapper')
      }, (0, _preact.h)("button", {
        className: "btn--cta btn--full-width btn--load-more ".concat(isLoading ? 'is-loading disabled' : ''),
        onClick: function onClick() {
          return _this3.setPagination(1);
        },
        type: "button"
      }, "Back to top of the list", (0, _preact.h)("span", {
        className: "loader"
      }))) : null, productUpdates.map(function (productUpdate) {
        return (0, _preact.h)(_ProductUpdateView.default, (0, _extends2.default)({
          key: productUpdate.id,
          categoryName: productUpdate === null || productUpdate === void 0 ? void 0 : productUpdate.categoryName,
          productAreasMapping: productAreasMapping
        }, productUpdate, {
          isGuest: isGuest,
          currentUser: currentUser,
          lastContributor: productUpdate.lastContributor,
          lastPostId: productUpdate.lastPostId,
          publicId: productUpdate.publicId
        }));
      }), currentPage < totalPageCount ? (0, _preact.h)("div", {
        className: "load-more-container card-widget-wrapper"
      }, (0, _preact.h)("button", {
        className: "btn--cta btn--full-width btn--load-more ".concat(isLoading ? 'is-loading disabled' : ''),
        onClick: function onClick() {
          return _this3.setPagination(currentPage + 1);
        },
        type: "button"
      }, (0, _preact.h)(_phrase.default, {
        p: "Show more"
      }), (0, _preact.h)("span", {
        className: "loader"
      }), (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/product-updates?page=".concat(currentPage + 1))
      }))) : null));
    }
  }], [{
    key: "overrideHistoryPushState",
    value: function overrideHistoryPushState() {
      var pushState = window.history.pushState.bind(window.history);

      window.history.pushState = function (state) {
        if (typeof window.history.onpushstate === 'function') {
          window.history.onpushstate({
            state: state
          });
        } // @ts-expect-error


        return pushState.apply(this, arguments);
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window === 'undefined') {
        return;
      }

      window.removeEventListener('popstate', ProductUpdatesOverview.handleBackNavigation);
    }
  }]);
  return ProductUpdatesOverview;
}(_preact.Component);

(0, _defineProperty2.default)(ProductUpdatesOverview, "handleBackNavigation", function () {
  return window.location.reload();
});
(0, _defineProperty2.default)(ProductUpdatesOverview, "onProductAreaSelect", function (productAreaId) {
  (0, _shared.updateQueryFilters)({
    productArea: productAreaId ? [productAreaId] : null
  });
});
var _default = ProductUpdatesOverview;
exports.default = _default;